import { Injectable } from '@angular/core';
import { entityMap } from './rating_entities';

@Injectable({
  providedIn: 'root'
})
export class EntityManagerService {

  constructor() { }

  getEntityInfoByEntityId(id: string) {
    try {
      return entityMap.filter( entity => entity.acronym === id )[0];
    } catch (e) {
      return null;
    }
  }
}
